<template>
  <v-row v-if="show" no-gutters>
    <v-col class="col-12 no-result-container">
      <v-img
        :alt="lang.response.noResult"
        class="mx-auto no-result"
        :src="require(`../assets/images/${image}`)"
      ></v-img>
      <p class="primary--text">{{ title }}</p>
      <v-btn
        v-if="button"
        outlined
        large
        class="mt-4 mb-6 primary--text"
        :to="button.link"
        >{{ button.text }}</v-btn
      >
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    button: {
      type: Object,
      default() {
        return null;
      },
    },
    image: {
      type: String,
      default: "search.jpg",
    },
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
};
</script>

<style lang="scss" scoped>
.no-result-container {
  background: #fff;
  margin: 0;
  margin-top: -12px;
  padding: 10px 10px 100px 10px;
  box-sizing: border-box;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  .no-result {
    width: 350px;
  }
  p {
    margin-top: -60px;
    z-index: 40;
    position: relative;
    font-size: 30px;
    font-weight: bold;
  }
}
@media only screen and (max-width: 600px) {
  .no-result-container {
    padding: 10px 10px 60px 10px;
    .no-result {
      width: 150px;
    }
    p {
      margin-top: 0;
      font-size: 16px;
    }
  }
}
</style>